import styles from "./empty-dash-cams.module.scss";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import illustration from "./illustration.svg";

export default function EmptyDashCams() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div
      className={styles.EmptyDashCamsWrapper}
      data-testid={"empty-dash-cams"}
    >
      <div className={styles.EmptyDashCams}>
        <img className={styles.Illustration} alt={""} src={illustration} />
        <h1 className={styles.Title}>{t("noLinkedDashCamsDetected")}</h1>
        <p className={styles.Paragraph}>{t("toLinkADashCamToYourAccount")}</p>
      </div>
    </div>
  );
}
